/* チェックボックス */
import React from 'react';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import { KeyValue } from '../types/KeyValue';

interface Props {
  id: string;
  value: string[];
  label: string;
  need?: boolean;
  sources: Array<KeyValue>;
  name: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  help_msg?: string;
  disabled: boolean;
  looks_inactive?: boolean;
  readonly?: boolean;
  css_class?: string;
}

const CheckBox: React.FC<Props> = ({
  id,
  value,
  label,
  need,
  sources,
  name,
  message,
  help_msg,
  disabled,
  handleChange,
  looks_inactive,
  readonly,
  css_class,
}) => {
  /**
   * チェックボックスを表示するJSX.Elementを返却する
   * @returns JSX.Element
   */
  const returnCheckboxJsx = () => {
    return (
      <div id={id}>
        {sources.map((src, index) => {
          return (
            <div className={`p-checkbox-with-txt ${css_class ?? ''}`} key={src.key}>
              <label className="check-box-label c-check-label">
                <input
                  key={`${id}-${index}`}
                  disabled={disabled || readonly}
                  id={`${id}-${index}`}
                  type="checkbox"
                  value={src.key}
                  defaultChecked={value.includes(src.key)}
                  onChange={handleChange}
                  className="input-checkbox"
                />
                <span className="check-icon" />
                <span className="check-txt">{src.value}</span>
              </label>
            </div>
          );
        })}
        <Messages help_msg={help_msg} valid_msg={message} />
      </div>
    );
  };

  /**
   * ラベルを表示するJSX.Elementを返却する
   * @returns JSX.Element
   */
  const returnLabelJsx = () => {
    // 配列の保有値を数値型に変換してソートする
    const new_value = value
      .map(val => Number(val))
      .sort((a, b) => {
        return a - b;
      });

    return (
      <>
        {new_value.map((val, index) => {
          return sources.map(src => {
            return (
              src.key === String(val) && (
                <React.Fragment key={`fragment-${id}-${index}`}>
                  <span key={`label-${id}-${index}`}>{src.value}</span>
                  {index < value.length && <br key={`br-${id}-${index}`} />}
                </React.Fragment>
              )
            );
          });
        })}
      </>
    );
  };

  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      looks_inactive={looks_inactive}
      content={
        <div className="p-checkbox-with">
          {disabled || looks_inactive ? returnLabelJsx() : returnCheckboxJsx()}
        </div>
      }
    />
  );
};

export default CheckBox;
